import { render, staticRenderFns } from "./ddqr.vue?vue&type=template&id=38f6c924&scoped=true&"
import script from "./ddqr.vue?vue&type=script&lang=js&"
export * from "./ddqr.vue?vue&type=script&lang=js&"
import style0 from "./ddqr.vue?vue&type=style&index=0&id=38f6c924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6c924",
  null
  
)

export default component.exports